import { useSearchParams } from 'react-router-dom';
import { ROUTES } from '../constants/routes';
import { BreadcrumbItem } from '../components/shared/Breadcrumb';

type NavigationSource = 'list' | 'kanban' | 'dashboard' | 'search';

interface UseBreadcrumbsOptions {
  currentPageTitle?: string;
  backUrl?: string;
}

interface UseBreadcrumbsReturn {
  breadcrumbItems: BreadcrumbItem[];
  source: NavigationSource | null;
  showBackButton: boolean;
  onBack?: () => void;
}

export const useBreadcrumbs = (options: UseBreadcrumbsOptions = {}): UseBreadcrumbsReturn => {
  const [searchParams] = useSearchParams();
  
  const source = searchParams.get('source') as NavigationSource | null;
  const boardType = searchParams.get('boardType');
  const { currentPageTitle = 'หน้าใบงาน', backUrl } = options;

  const getBreadcrumbItems = (): BreadcrumbItem[] => {
    if (!source) return [];

    const sourceConfig = {
      list: { label: 'ทะเบียนใบงาน', href: ROUTES.MOLD_ORDERS },
      mold_list: { label: 'ทะเบียนแม่พิมพ์', href: ROUTES.MOLDS },
      kanban: { 
        label: 'บอร์ดใบงาน', 
        href: boardType ? `${ROUTES.DASHBOARD}?boardType=${boardType}` : ROUTES.DASHBOARD 
      },
      dashboard: { label: 'หน้าหลัก', href: '/' },
      search: { label: 'ผลการค้นหา', onClick: () => window.history.back() }
    };

    const sourceItem = sourceConfig[source as keyof typeof sourceConfig];
    if (!sourceItem) return [];

    return [
      sourceItem,
      { label: currentPageTitle }
    ];
  };

  const breadcrumbItems = getBreadcrumbItems();
  const showBackButton = breadcrumbItems.length > 0;
  
  // Custom back function that respects the source
  const handleBack = () => {
    if (backUrl) {
      window.location.href = backUrl;
      return;
    }

    switch (source) {
      case 'list':
        window.location.href = ROUTES.MOLD_ORDERS;
        break;
      case 'kanban':
        const kanbanUrl = boardType 
          ? `${ROUTES.DASHBOARD}?boardType=${boardType}`
          : ROUTES.DASHBOARD;
        window.location.href = kanbanUrl;
        break;
      case 'dashboard':
        window.location.href = '/';
        break;
      default:
        window.history.back();
    }
  };

  return {
    breadcrumbItems,
    source,
    showBackButton,
    onBack: showBackButton ? handleBack : undefined
  };
};
